import React, { Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import FeatureSection from "./FeatureSection";
import PricingSection from "./PricingSection";
import { Auth } from 'aws-amplify';

function Home(props) {
  const { selectHome } = props;

  useEffect(() => {
    selectHome();
  }, [selectHome]);
  Auth.currentSession()
  .then(data => props.history.push('/c/dashboard'))
  .catch(err => console.log(err));

  return (

    <Fragment>

      <PricingSection />

      <FeatureSection />

    </Fragment>
  );
}

Home.propTypes = {
  selectHome: PropTypes.func.isRequired
};

export default Home;
